export enum VideoThemeType {
  Public = 0,
  Premium = 1,
  Organization = 2
}
